import { cn } from '@/utils/cn'
import type { ReactMarkdownOptions } from 'react-markdown/lib/react-markdown'
import { ReactMarkdown } from 'react-markdown/lib/react-markdown'
import remarkBreaks from 'remark-breaks'
import remarkGfm from 'remark-gfm'

const markdownStyles = cn('[&_a]:text-accent [&_a]:underline')

export function Markdown({ className, ...props }: ReactMarkdownOptions) {
  return (
    <ReactMarkdown
      remarkPlugins={[remarkGfm, remarkBreaks]}
      components={components}
      className={cn(markdownStyles, className)}
      {...props}
    />
  )
}

const components: ReactMarkdownOptions['components'] = {
  a: (props) => <a {...props} target="_blank" />,
}
